
export const arrayMedian = (vals) => {
  // @see https://en.wikipedia.org/wiki/Median#Finite_set_of_numbers
  const sortedVals = [...vals].sort((a, b) => a - b);
  const half = Math.floor(sortedVals.length / 2);
  if (sortedVals.length % 2)
    return sortedVals[half];
  return (sortedVals[half - 1] + sortedVals[half]) / 2;
};
